import { getReferralCodeFromLocation, getStoredReferralCode } from "./referral";

/** Must match `Tawan Spa/server/utils/tawanQr.js`. */
export const REGISTRATION_SITE = "dr-hoffmann-massage";

export const CAMPAIGN_SOURCE_COOKIE = "mediconsult_campaign_source";
export const CAMPAIGN_PATH_COOKIE = "mediconsult_campaign_path";
const MAX_AGE_SEC = 60 * 60 * 24 * 30;

const readCookie = (name) => {
  if (typeof document === "undefined") return null;
  const prefix = `${name}=`;
  const hit = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  if (!hit) return null;
  try {
    return decodeURIComponent(hit.slice(prefix.length));
  } catch {
    return hit.slice(prefix.length);
  }
};

const writeCookie = (name, value) => {
  if (typeof document === "undefined" || !value) return;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${MAX_AGE_SEC}; SameSite=Lax`;
};

/** Persist ?source= from any landing page (e.g. /buchen?source=newsletter). */
export const captureCampaignSourceFromLocation = (location) => {
  if (!location) return;
  const campaign = new URLSearchParams(location.search || "").get("source")?.trim();
  if (!campaign) return;
  writeCookie(CAMPAIGN_SOURCE_COOKIE, campaign.toLowerCase());
  const path = String(location.pathname || "").trim();
  if (path) writeCookie(CAMPAIGN_PATH_COOKIE, path);
};

export const getStoredCampaignSource = () => readCookie(CAMPAIGN_SOURCE_COOKIE);

export const getStoredCampaignPath = () => readCookie(CAMPAIGN_PATH_COOKIE);

export const buildRegistrationPayload = (location) => {
  const params = new URLSearchParams(location.search);
  const fromUrl = params.get("source")?.trim();
  const stored = getStoredCampaignSource();
  const campaign = fromUrl || stored;
  const storedPath = getStoredCampaignPath();
  const referralCode = getReferralCodeFromLocation(location);

  return {
    source: campaign ? campaign.toLowerCase() : "webseite",
    registrationSite: REGISTRATION_SITE,
    registrationPath: storedPath || location.pathname,
    ...(referralCode ? { referralCode } : {}),
  };
};

export const buildAuthHref = (authPath, { next } = {}) => {
  const params = new URLSearchParams();
  if (next) params.set("next", next);
  const stored = getStoredCampaignSource();
  if (stored) params.set("source", stored);
  const referralCode = getStoredReferralCode();
  if (referralCode) params.set("ref", referralCode);
  const qs = params.toString();
  return qs ? `${authPath}?${qs}` : authPath;
};

export const buildBuchenAuthHref = (authPath, optionId) => {
  const nextParams = new URLSearchParams({ option: optionId });
  const stored = getStoredCampaignSource();
  if (stored) nextParams.set("source", stored);
  return buildAuthHref(authPath, { next: `/buchen?${nextParams.toString()}` });
};

/** Track Leonardo Hotel tablet registrations (dedicated campaign source). */
export const captureLeonardoRegistrationSource = ({
  source = "leonardo-nikolai",
  path = "/leonardo-nikolai",
} = {}) => {
  writeCookie(CAMPAIGN_SOURCE_COOKIE, source);
  writeCookie(CAMPAIGN_PATH_COOKIE, path);
};

export const buildLeonardoAuthHref = (authPath, optionId) => {
  const nextParams = new URLSearchParams();
  if (optionId) nextParams.set("option", optionId);
  return buildAuthHref(authPath, {
    next: nextParams.toString()
      ? `/leonardo-nikolai?${nextParams.toString()}`
      : "/leonardo-nikolai",
  });
};
